import React from 'react'

const ImageComponent = props => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default ImageComponent
